<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar flat color="#008dd4" dark>
                <v-btn icon @click="$parent.create_dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Registrar curso</v-toolbar-title>
            </v-toolbar>
            <v-container>
                <v-form ref="create" v-on:submit.prevent="submit($event)">
                    <v-row>
                        <v-col cols="12" lg="6" md="10" class="mx-auto">
                            <v-text-field v-model="name" filled :color="color" label="Nombre" :rules="[rules.required]"></v-text-field>
                            <v-menu
                                ref="menu"
                                :color="color"
                                :header-color="color"
                                v-model="startdate_dialog"
                                :close-on-content-click="false"
                                :return-value.sync="start_date"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="start_date" filled :color="color" label="Fecha de inicio" readonly v-bind="attrs" v-on="on" :rules="[rules.required]"></v-text-field>
                                </template>
                                <v-date-picker v-model="start_date" color="#008dd4" no-title scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text :color="color" @click="birthdate_dialog = false">Cancelar</v-btn>
                                    <v-btn color="#008dd4" @click="$refs.menu.save(start_date)" dark>Aceptar</v-btn>
                                </v-date-picker>
                            </v-menu>
                            <v-select v-model="modality" :items="modalities" :rules="[rules.required]" filled item-text="name" item-value="id" :color="color" label="Modalidad" :item-color="color"></v-select>
                            <v-select v-model="level" :items="levels" :rules="[rules.required]" filled item-text="name" item-value="id" :color="color" label="Nivel" :item-color="color"></v-select>
                            <v-select v-model="teacher_id" :items="teachers" filled item-text="names" item-value="id" :color="color" label="Docente" :item-color="color" no-data-text="Sin registros"></v-select>
                            <v-select v-model="language_id" :items="languages" :rules="[rules.required]" filled item-text="language" item-value="id" :item-color="color" :color="color" label="Idioma" no-data-text="Sin registros"></v-select>
                            <v-text-field v-model="inscription_price" filled :color="color" type="number" label="Precio de inscripción" :rules="[rules.required]" step="0.1"></v-text-field>
                            <v-text-field v-model="monthly_payment" filled :color="color" type="number" label="Precio de mensualidad" :rules="[rules.required]" step="0.1"></v-text-field>
                            <v-text-field v-model="student_limit" filled :color="color" type="number" label="Límite de alumnos" :rules="[rules.required]" step="1" min="1"></v-text-field>
                            <v-textarea v-model="description" filled :color="color" label="Descripción"></v-textarea>
                            <v-data-table :headers="headers" :no-data-text="no_data_text" :items="selected_days" hide-default-footer>
                                <template v-slot:top>
                                    <v-container fill-height fluid>
                                        <v-row align="center" justify="center">
                                            <v-col cols="6">
                                                <h3 class="mb-0">Horario</h3>
                                            </v-col>
                                            <v-col cols="6" class="text-right">
                                                <v-tooltip left>
                                                    <template v-slot:activator="{ on, attrs }">
                                                            <v-btn fab color="#008dd4" v-bind="attrs" v-on="on" :disabled="!modality != ''" @click="schedule_modal = !schedule_modal">
                                                                <v-icon>mdi-plus-circle</v-icon>
                                                            </v-btn>
                                                    </template>
                                                    <span>Añadir</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </template>

                                <template v-slot:item.actions="{ item }">
                                    <v-tooltip right>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" icon @click="deleteSchedule(item)">
                                                <v-icon>mdi-minus-circle</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Eliminar</span>
                                    </v-tooltip>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" lg="6" md="10" class="text-right mx-auto">
                            <v-btn type="submit" :loading="loading" color="#008dd4" dark>Registrar</v-btn>
                            <v-btn @click="cancel" :disabled="loading" text>Cancelar</v-btn>
                        </v-col>
                    </v-row>
                </v-form>

                <v-dialog v-model="schedule_modal" persistent width="800">
                    <v-card>
                        <v-form v-on:submit.prevent="addSchedule">
                            <v-card-title :color="color">Agregar horario</v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col>
                                            <v-select filled v-model="day" :color="color" :items="semi_intensive" item-value="name" item-text="name" label="Día" :item-color="color" v-if="modality == 1"></v-select>
                                            <v-select filled v-model="day" :color="color" :items="intensive" item-value="name" item-text="name" label="Día" :item-color="color" v-if="modality == 2"></v-select>
                                            <v-select filled v-model="day" :color="color" :items="saturday" item-value="name" item-text="name" label="Día" :item-color="color" v-if="modality == 3"></v-select>
                                            <v-select filled v-model="day" :color="color" :items="childish" item-value="name" item-text="name" label="Día" :item-color="color" v-if="modality == 4 || modality == 5"></v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row justify="space-around" align="center">
                                        <v-col style="width: 350px; flex: 0 1 auto;">
                                            <h4>Hora de inicio:</h4>
                                            <v-time-picker v-model="start" :color="color" :max="end"></v-time-picker>
                                        </v-col>
                                        <v-col style="width: 350px; flex: 0 1 auto;">
                                            <h4>Hora final:</h4>
                                            <v-time-picker v-model="end" :color="color" :min="start"></v-time-picker>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn type="submit" text>Aceptar</v-btn>
                                <v-btn text @click="schedule_modal = false" color="error">Cancelar</v-btn>
                            </v-card-actions>
                        </v-form>
                    </v-card>
                </v-dialog>

            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>

import iziToast from 'izitoast'

export default {
    props:['dialog','store_url','modalities','levels','teachers','languages','onsite'],
    data: () => ({
        color: "#000",

        startdate_dialog:false,
        schedule_modal:false,
        loading:false,

        day:"",
		start:"",
		end:"",

        semi_intensive:[
            {name:"Lunes", abb:"L"},
            {name:"Miércoles", abb:"Mi"},
            {name:"Viernes", abb:"V"}
        ],

        intensive:[
            {name:"Martes", abb:"M"},
            {name:"Jueves", abb:"J"},
        ],

        saturday:[
            {name:"Sábado", abb:"S"},
        ],

        childish:[
            {name:"Lunes", abb:"L"},
            {name:"Martes", abb:"M"},
            {name:"Miércoles", abb:"Mi"},
            {name:"Jueves", abb:"J"},
            {name:"Viernes", abb:"V"}
        ],



        selected_days:[],

        time:"",

        //datatable props
        no_data_text:"Sin días registrados",
        headers:[
            { text:'Día', value:'name' },
            { text:'Hora inicial', value:'start' },
            { text:'Hora final', value:'end' },
            { text: 'Acciones', value:'actions', sorteable:false}
        ],

        rules:{
            required: v => !!v || 'El campo es requerido',
        },

        //models
        name:"",
        start_date:"",
        modality:"",
        level:"",
        teacher_id:"",
        inscription_price:"",
        monthly_payment:"",
        student_limit:"",
        description:"",
        language_id:"",
    }),

    watch:{
        modality:function(){
            this.selected_days = []
        }
    },

	methods:{
        addSchedule:function(){
            if(this.day != "" && this.start != "" && this.end != ""){

                for(let element of this.selected_days){
                    if(element.name == this.day){
                        this.selected_days.splice(this.selected_days.indexOf(element), 1)
                    }
                }
                
                
                this.selected_days.push({
                    name : this.day,
                    start : this.start,
                    end : this.end
                })
                //CODIGO QUE HAY QUE ARREGLAR ES UNA SOUCION RAPIDA
                if(this.modality == 1  ){
                    this.selected_days = [] 
                    this.semi_intensive.forEach(element => {
                        this.selected_days.push({
                            name : element.name,
                            start : this.start,
                            end : this.end
                        })
                    });
                } 
                if(this.modality == 2 ){
                    this.selected_days = [] 
                    this.intensive.forEach(element => {
                        this.selected_days.push({
                            name : element.name,
                            start : this.start,
                            end : this.end
                        })
                    });
                } 
                // HASTA AQUI EL CODIGO FEO
                this.day = ""
                this.start = ""
                this.end = ""

                this.schedule_modal = false
            }
        },

        deleteSchedule:function(item){
            this.selected_days.splice(this.selected_days.indexOf(item), 1)
        },

        submit:function(event){
            if(this.$refs.create.validate()){
                if(this.selected_days.length < 1){
                    iziToast.error({
                        title:"Error",
                        position:'topRight',
                        message: 'Debe agregar al menos 1 día al horario de clase'
                    })
                }else{
                    let data = {}
                    data.name = this.name
                    data.start_date = this.start_date
                    data.modality = this.modality
                    data.level = this.level
                    data.teacher_id = this.teacher_id
                    data.inscription_price = this.inscription_price
                    data.monthly_payment = this.monthly_payment
                    data.language_id = this.language_id
                    data.student_limit = this.student_limit
                    data.description = this.description
                    data.schedule = this.selected_days
                    data.onsite = this.onsite

                    this.loading = true

                    axios.post(this.store_url, data).then(response => {
                        this.cancel()
                        iziToast.success({
                            title:"Correcto",
                            position:"topRight",
                            message:"Curso registrado correctamente"
                        })

                        this.$parent.getData()

                    }).catch(error => {
                        this.loading = false
                        if(error.response.data.errors){
                            for(let prop in error.response.data.errors){
                                for(let message of error.response.data.errors[prop]){
                                    iziToast.error({
                                        title:"Error",
                                        position:'topRight',
                                        message: message
                                    })
                                }
                            }
                        }
                    })
                }
            }
        },

        cancel:function(){
            this.$refs.create.reset()
            this.loading = false
            this.selected_days = []
            this.$parent.create_dialog = false
        }
	}
}
</script>
